import OrderCargoOrderAbandonedDownloadRequest, {
  OrderCargoOrderAbandonedDownloadQueryParams,
} from "./order-cargo-order-abandoned-download.request";

const createQueryParams = (
  request: OrderCargoOrderAbandonedDownloadRequest,
): OrderCargoOrderAbandonedDownloadQueryParams => {
  return {
    order: request.order,
    address: request.address,
    client: request.client,
    creationEnd: request.creationEnd,
    creationStart: request.creationStart,
    dispatch: request.dispatch,
    endAddress: request.endAddress,
    externalId: request.externalId,
    humanId: request.humanId,
    midAddress: request.midAddress,
    passenger: request.passenger,
    publicStatus: request.publicStatus,
    startAddress: request.startAddress,
    startTimeSince: request.startTimeSince,
    startTimeTo: request.startTimeTo,
  };
};

const orderCargoOrderAbandonedDownloadRequestFactory = {
  createQueryParams,
};

export default orderCargoOrderAbandonedDownloadRequestFactory;
